<template>
    <div v-if="hasSearchFeature" class="resource-search-with-filter">
        <vx-input
            class="resource-search-with-filter__input"
            placeholder="Search"
            v-model.trim="search"
            :disabled="isCollectionLoading"
            @keydown.enter="onEnter"
        >
            <template #before>
                <vx-icon
                    :name="isSearching ? 'spinner' : 'search-bold'"
                    :size="16"
                    class="resource-search-with-filter__search-icon"
                ></vx-icon>
            </template>
            <template #after>
                <slot name="filters"></slot>
            </template>
        </vx-input>
        <div v-if="searchHelpPopoverText" class="resource-search-with-filter__help">
            <vx-modal-dropdown offsetDistance="18">
                <template #trigger>
                    <label class="resource-search-with-filter__help-label">{{ helpLabel }}</label>
                </template>
                <template #content>
                    <div v-html="searchHelpPopoverText"></div>
                </template>
            </vx-modal-dropdown>
        </div>
    </div>
    <div v-else>
        <slot name="filters"></slot>
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { VxInput, VxIcon, VxModalDropdown } from '@voxie/frontend-components-v3';

const props = defineProps({
    value: { type: String, required: true },
    searchHelpPopoverText: { type: String, default: '' },
    hasSearchFeature: { type: Boolean },
    isSearching: { type: Boolean },
    isCollectionLoading: { type: Boolean },
    helpLabel: { type: String, default: 'Search Help' },
});

const emit = defineEmits(['run:search']);

const search = ref('');

watchEffect(() => {
    search.value = props.value;
});

const onEnter = () => {
    if (props.value !== search.value) emit('run:search', search.value);
};
</script>

<style lang="scss">
.resource-search-with-filter {
    position: relative;
}

.resource-search-with-filter__input {
    display: flex;
    width: 300px;
}

.resource-search-with-filter__search-icon {
    color: var(--fc-color-gray-40);
}

.resource-search-with-filter__help {
    position: absolute;
    width: 300px;
    top: 24px;
}

.resource-search-with-filter__help-label {
    position: absolute;
    font-family: var(--font-dm-sans);
    font-weight: var(--weight-regular);
    font-size: 0.75rem;
    white-space: nowrap;
    color: var(--color-primary);
    margin: 0;
    cursor: pointer;
}
</style>
